import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare } from "@fortawesome/free-solid-svg-icons";
import "./ExecutionAndDocumentationMobileView.css";
import { faArrowRightFromBracket } from "@fortawesome/free-solid-svg-icons";
import { faArrowUpRightFromSquare } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useState, useRef } from "react";
import "../DesktopView/ExecutionAndDocumentationDesktopView.css";
import axios from "axios";
import { useLocation } from "react-router-dom";
import CryptoJS from "crypto-js";
import JSZip from "jszip";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";

function ExecutionAndDocumentationMobileStep3({
  getDocument,
  documentResponse,
}) {
  const baseAPI = process.env.REACT_APP_API_URL;
  const baseImageURL = process.env.REACT_APP_IMAGE_URL;
  const location = useLocation();
  const fileInputRef = useRef(null);
  const [isUploaded, setIsUploaded] = useState(false);
  const [uploadedDocumentTypeId, setUploadedDocumentTypeId] = useState(null);

  const searchParams = new URLSearchParams(location.search);
  const encryptedRelocationID = searchParams.get("ID");
  const Relocation_ID = decryptRelocationID(encryptedRelocationID);

  const [individualDocResponse, setIndividualDocResponse] = useState(null);
  const [individualDocResponse2, setIndividualDocResponse2] = useState(null);

  const [dateValue1, setDateValue1] = useState("");
  const [dateValue2, setDateValue2] = useState("");

  let updateData = documentResponse;

  const [firstItem, setFirstItem] = useState({
    relocation_id: Relocation_ID,
    doc_ID: "",
    documentTypeId: "",
    manual_createdDate: "",
    document: "",
    doc_name: "",
    is_Active: "",
    is_submit: "",
    reference_number: "",
    user_type: 3,
  });

  useEffect(() => {
    getIndividualDoc(13);
    getIndividualDoc(15);

    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (updateData) {
      const individualDocResponse = updateData.filter(
        (doc) => doc.document_type_id === 13
      );
      const individualDocResponse2 = updateData.filter(
        (doc) => doc.document_type_id === 15
      );

      setIndividualDocResponse(individualDocResponse);
      setIndividualDocResponse2(individualDocResponse2);
    }
  }, [updateData]);

  function decryptRelocationID(ciphertext) {
    try {
      const bytes = CryptoJS.AES.decrypt(
        decodeURIComponent(ciphertext),
        "dbbworldwidepvtltd"
      );
      return bytes.toString(CryptoJS.enc.Utf8);
    } catch (error) {
      console.error("Error decrypting Relocation_ID:", error);

      return null;
    }
  }

  function handleChangeDoc(e) {
    const { name, value, files } = e.target;

    if (name === "doc_name") {
      const file = files[0];
      if (file.size > 50 * 1024 * 1024) {
        alert("File size exceeds 50 MB limit.");
        e.target.value = null;
        return;
      }

      if (isValidFileType(file)) {
        if (
          file.type === "application/zip" ||
          file.type === "application/x-zip-compressed"
        ) {
          validateZipFile(file, name, e);
        } else {
          getUpdatedImage(file, name);
        }
      } else {
        alert("Unsupported file type. Please upload a valid file.");
        // Reset the file input field
        e.target.value = null;
        return;
      }
    } else {
      setFirstItem({
        ...firstItem,
        [name]: value,
      });
    }
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "dateValue1") {
      setDateValue1(value);
    } else if (name === "dateValue2") {
      setDateValue2(value);
    }
  };

  function isValidFileType(file) {
    const allowedTypes = [
      "image/jpeg",
      "image/png",
      "application/pdf",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // DOCX
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // XLSX
      "application/vnd.ms-excel", // XLS
      "video/mp4",
      "video/x-msvideo", // AVI
      "video/x-matroska", // MKV
      "video/quicktime", // MOV
      "application/zip", // ZIP
      "application/x-zip-compressed", // Alternate ZIP MIME type
    ];
    return file && allowedTypes.includes(file.type);
  }

  function validateZipFile(file, name, e) {
    const reader = new FileReader();
    reader.onload = function (event) {
      const zipData = event.target.result;

      try {
        const jszip = new JSZip();
        jszip.loadAsync(zipData).then((zip) => {
          const allowedExtensions = ["jpg", "png", "pdf", "docx", "xlsx"];
          let isValid = true;

          zip.forEach((relativePath, zipEntry) => {
            const extension = relativePath.split(".").pop().toLowerCase();
            if (!allowedExtensions.includes(extension)) {
              isValid = false;
            }
          });

          if (isValid) {
            getUpdatedImage(file, name);
          } else {
            alert("ZIP file contains unsupported file types.");
            e.target.value = null;
          }
        });
      } catch (error) {
        alert("Error reading ZIP file.");
        e.target.value = null;
      }
    };
    reader.readAsArrayBuffer(file);
  }

  function getUpdatedImage(file, name) {
    if (file) {
      setFirstItem({
        ...firstItem,
        [name]: file, // Store the file object directly
      });
    }
  }

  function getIndividualDoc(documentTypeId) {
    const storedToken = JSON.parse(localStorage.getItem("accessToken"));

    if (storedToken) {
      axios
        .get(
          `${baseAPI}customerget/GetCustomerDocumentsDetail?relocation_id=` +
            Relocation_ID +
            `&option=1&is_submit=0&documentTypeId=0`,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )
        .then((response) => {
          let data = response.data.data;

          // Divide the array based on documentTypeId
          const individualDocResponse = data.filter(
            (doc) => doc.document_type_id === 13
          );
          const individualDocResponse2 = data.filter(
            (doc) => doc.document_type_id === 15
          );

          // Set the responses
          setIndividualDocResponse(individualDocResponse);
          setIndividualDocResponse2(individualDocResponse2);
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  }

  const uploadVaccinationBook = async (documentTypeId) => {
    if (!firstItem.doc_name) {
      alert("Please select a file before uploading.");
      return; // Exit the function early if no file is selected
    }

    const formData = new FormData();

    if (documentTypeId === 13) {
      firstItem.manual_createdDate = dateValue1;
    }

    if (documentTypeId === 15) {
      firstItem.manual_createdDate = dateValue2;
    }

    // Append form fields and the file to FormData
    formData.append("relocation_id", Relocation_ID);
    formData.append("documentTypeId", documentTypeId);
    formData.append("manual_createdDate", firstItem.manual_createdDate);
    formData.append("doc_name", firstItem.doc_name);
    formData.append("user_type", 3);
    formData.append("reference_number", firstItem.reference_number);

    try {
      const storedToken = JSON.parse(localStorage.getItem("accessToken"));
      const response = await axios.post(
        `${baseAPI}customerpost/UpdateCustomerDocumentsDetail`,
        formData, // Send request body
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (response.status === 200) {
        setIsUploaded(true); // Set upload status to true on success
      }
      setUploadedDocumentTypeId(documentTypeId);
      getIndividualDoc(documentTypeId);

      setFirstItem({
        relocation_id: Relocation_ID,
        doc_ID: "",
        documentTypeId: "",
        manual_createdDate: "",
        document: "",
        doc_name: "",
        is_Active: "",
        is_submit: "",
        reference_number: "",
        user_type: 3,
      });

      setDateValue1("");
      setDateValue2("");

      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
    } catch (error) {
      console.error("Error posting data:", error);
    }
  };

  async function deleteDoc(doc_ID) {
    const isConfirmed = window.confirm(
      "Are you sure you want to delete this document?"
    );

    if (isConfirmed) {
      const storedToken = JSON.parse(localStorage.getItem("accessToken"));
      // Make a POST request to your API endpoint
      const response = await axios.post(
        `${baseAPI}customerpost/UpdateCustomerDocsDelete`,
        {
          doc_ID: doc_ID, // Request body
        },
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      );
      setIndividualDocResponse((prevDocs) =>
        prevDocs.filter((doc) => doc.doc_ID !== doc_ID)
      );

      setIndividualDocResponse2((prevDocs) =>
        prevDocs.filter((doc) => doc.doc_ID !== doc_ID)
      );
    }
  }

  async function submitDocument(doc_ID) {
    try {
      const storedToken = JSON.parse(localStorage.getItem("accessToken"));
      // Make a POST request to your API endpoint
      const response = await axios.post(
        `${baseAPI}customerpost/UpdateCustomerDocsSubmit`,
        { doc_ID: doc_ID },
        {
          // Send request body
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      );

      getDocument();
    } catch (error) {
      // Handle errors (e.g., show an error message)
      console.error("Error posting data:", error);
    }
  }

  const formatDate = (dateString) => {
    const options = {
      day: "numeric",
      month: "short",
      year: "numeric",
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    };

    const formattedDate = new Date(dateString).toLocaleString("en-US", options);
    return formattedDate;
  };

  return (
    <>
      <div
        className="py-4 px-2 mt-4"
        style={{ backgroundColor: "rgb(250, 250, 250)", borderRadius: "8px" }}
      >
        <h4 style={{ fontSize: "14px" }}>1. Address or ID Proof.</h4>
        <h6
          className="px-3 py-0"
          style={{ fontSize: "12.5px", color: "#A0A0A0" }}
        >
          We require the pet parent's address or ID proof to verify the owner's
          address and ensure a smooth KYC process.{" "}
          <span style={{ color: "#0096EB" }}>More Info</span>
        </h6>
        <h4
          className="px-3 py-0"
          style={{ fontSize: "12.5px", marginTop: "23px" }}
        >
          Date of Document submission
        </h4>
        <div className="row px-3">
          <form className="form-row col-12 p-0 execution-step-2-form">
            <input
              style={{
                border: "1px solid #BEBEBE",
                borderTopLeftRadius: "8px",
                borderBottomLeftRadius: "8px",
                fontSize: "14px",
                height: "38px",
              }}
              type="date"
              placeholder="Enter"
              className="form-input"
              name="dateValue1"
              value={dateValue1}
              onChange={handleChange}
            />
            <button
              style={{
                border: "1px solid #5B489D",
                height: "36px",
                fontSize: "14px",
                backgroundColor: "#F8F9FACC",
                color: "#6a6a6a",
                with: "114px",
                padding: "4px 27px 4px 27px",
                borderTopRightRadius: "8px",
                borderBottomRightRadius: "8px",
              }}
              type="submit"
              className="form-button update-btn-new"
            >
              Update
            </button>
          </form>
          <form className="form-row col-12 px-0 py-3 execution-step-2-form">
            <input
              style={{
                border: "1px solid #BEBEBE",
                borderTopLeftRadius: "8px",
                borderBottomLeftRadius: "8px",
                fontSize: "14px",
                height: "38px",
              }}
              type="file"
              placeholder="Enter"
              className="form-input"
              name="doc_name"
              onChange={handleChangeDoc}
              ref={fileInputRef}
              required
            />
            <button
              style={{
                border: "1px solid #5B489D",
                height: "36px",
                fontSize: "14px",
                backgroundColor: "#F8F9FACC",
                color: "#6a6a6a",
                with: "114px",
                padding: "4px 27px 4px 27px",
                borderTopRightRadius: "8px",
                borderBottomRightRadius: "8px",
              }}
              className="form-button update-btn-new"
              onClick={(e) => {
                e.preventDefault(); // Explicitly prevent default form submission
                uploadVaccinationBook(13); // Call the function with your desired parameter
              }}
            >
              Upload
            </button>
          </form>

          {individualDocResponse?.length > 0 ? (
            <>
              <div className="px-3">
                <hr />
              </div>
              {individualDocResponse.map((item, index) => (
                <div
                  className="container-fluid mt-1 d-flex justify-content-between align-items-center py-2"
                  style={{
                    borderRadius: "7px",
                    boxShadow:
                      "rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px",
                    backgroundColor: "white",
                  }}
                  key={item.doc_ID}
                >
                  <div className="order-main-list d-flex flex-column align-items-start px-2">
                    <h4 style={{ fontSize: "17px", color: "#6A6A6A" }}>
                      Address or ID Proof
                    </h4>
                    <h5 style={{ fontSize: "11px", color: "#6A6A6A" }}>
                      {formatDate(item.manual_createdDate)}
                    </h5>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-end",
                    }}
                  >
                    {item.is_submit === 2 ? (
                      <a
                        style={{
                          display: "flex",
                          color: "#00A3FF",
                          textDecoration: "none",
                          cursor: "pointer",
                          fontWeight: "bold",
                        }}
                        target="_blank"
                        rel="noopener noreferrer"
                        href={`${baseImageURL}Images/Documents/${item.relocation_id}/${item.doc_name}`}
                        download={`${item.doc_name}`}
                      >
                        Preview{" "}
                        <FontAwesomeIcon
                          icon={faArrowUpRightFromSquare}
                          style={{
                            padding: "5px 4px 0px 11px",
                            color: "#00A3FF",
                          }}
                        />
                      </a>
                    ) : null}
                    {item.is_submit === 2 ? (
                      <button
                        style={{
                          color: "#28A745",
                          fontWeight: "bold",
                          textDecoration: "none",
                          border: "none",
                          backgroundColor: "white",
                          display: "flex",
                        }}
                        onClick={() => submitDocument(item.doc_ID)}
                      >
                        Submit
                        <FontAwesomeIcon
                          icon={faArrowRightFromBracket}
                          style={{
                            padding: "5px 4px 0px 11px",
                            color: "#28A745",
                          }}
                        />
                      </button>
                    ) : (
                      <button
                        style={{
                          color: "#28A745",
                          width: "88%",
                          marginTop: "9.5px",
                          fontWeight: "bold",
                          cursor: "default",
                          textDecoration: "none",
                          border: "none",
                          backgroundColor: "white",
                        }}
                      >
                        Submitted
                      </button>
                    )}

                    {item.is_submit === 2 ? (
                      <button
                        onClick={() => deleteDoc(item.doc_ID)}
                        style={{
                          display: "flex",
                          color: "#FF0004",
                          borderStyle: "none",
                          background: "none",
                        }}
                      >
                        Delete{" "}
                        <DeleteOutlinedIcon
                          className="icon"
                          style={{ padding: "0 0 0 4px" }}
                        />
                      </button>
                    ) : null}
                  </div>
                </div>
              ))}
            </>
          ) : null}
        </div>
      </div>
      <div
        className="py-4 px-2 mt-4"
        style={{ backgroundColor: "rgb(250, 250, 250)", borderRadius: "8px" }}
      >
        <h4 style={{ fontSize: "14px" }}>2. Pan Card</h4>
        <h6
          className="px-3 py-0"
          style={{ fontSize: "12.5px", color: "#A0A0A0" }}
        >
          We require the PAN Card of the pet parent to ensure a smooth KYC
          process. <span style={{ color: "#0096EB" }}>More Info</span>
        </h6>
        <form className="relocation-details-main-form mt-0 p-0 execution-step-2-form">
            <div className="form-row mt-0 row d-flex flex-column align-items-start">
            <div className="col-12 p-0">
              <label
                style={{
                  color: "#6a6a6a",
                  marginTop: "15px",
                  fontSize: "14px",
                }}
                className=""
                htmlFor="ownerName"
              >
                Enter PAN Number
              </label>
              <input
                id="microchipNumber"
                style={{
                  border: "1px solid #BEBEBE",
                  width: "100%",
                  fontSize: "14px",
                }}
                type="text"
                className="form-control m-0"
                placeholder="Enter"
                name="reference_number"
                value={firstItem.reference_number}
                onChange={handleChangeDoc}
              />
            </div>
              <div className="col-12 p-0">
                <label
                  style={{
                    color: "#3D3D3D",
                    marginTop: "15px",
                    fontSize: "14px",
                  }}
                  className=""
                  htmlFor="vaccinationDate"
                >
                  Date of PAN Card submission.
                </label>
                <input
                  id="vaccinationDate"
                  style={{
                    border: "1px solid #6a6a6a",
                    width: "100%",
                    fontSize: "14px",
                  }}
                  type="date"
                  className="form-control m-0"
                  placeholder="Enter"
                  name="dateValue2"
                  value={dateValue2}
                  onChange={handleChange}
                />
              </div>

              <div className="col-12 p-0" style={{ marginTop: "15px" }}>
                <div className="d-flex align-items-baseline mt-2">
                  <input
                    style={{
                      border: "1px solid #BEBEBE",
                      borderTopLeftRadius: "8px",
                      borderBottomLeftRadius: "8px",
                      fontSize: "14px",
                      height: "38px",
                    }}
                    type="file"
                    placeholder="Enter"
                    className="form-input"
                    name="doc_name"
                  onChange={handleChangeDoc}
                  ref={fileInputRef}
                  required
                  />
                  <button
                    style={{
                      border: "1px solid #5B489D",
                      height: "36px",
                      fontSize: "14px",
                      backgroundColor: "#F8F9FACC",
                      color: "#6a6a6a",
                      with: "114px",
                      padding: "4px 27px 4px 27px",
                      borderTopRightRadius: "8px",
                      borderBottomRightRadius: "8px",
                    }}
                    type="submit"
                    className="form-button update-btn-new"
                    onClick={(e) => {
                    e.preventDefault(); // Explicitly prevent default form submission
                    uploadVaccinationBook(15); // Call the function with your desired parameter
                  }}
                  >
                    Upload
                  </button>
                </div>
              </div>
            </div>
          </form>
          {individualDocResponse2?.length > 0 ? (
          <>
            <div className="px-3">
              <hr />
            </div>
            {individualDocResponse2.map((item, index) => (
              <div
                className="container-fluid mt-1 d-flex justify-content-between align-items-center py-2"
                style={{
                  borderRadius: "7px",
                  boxShadow:
                    "rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px",
                  backgroundColor: "white",
                }}
                key={item.doc_ID}
              >
                <div className="order-main-list d-flex flex-column align-items-start px-2">
                  <h4 style={{ fontSize: "17px", color: "#6A6A6A" }}>
                  PAN Card
                  </h4>
                  <h5 style={{ fontSize: "11px", color: "#6A6A6A" }}>
                    {formatDate(item.manual_createdDate)}
                  </h5>
                </div>
                <div style={{display: "flex",flexDirection: "column",alignItems: "flex-end"}}>                 

                  {item.is_submit === 2 ? (
                    <a
                      style={{
                        display: "flex",
                        color: "#00A3FF",
                        textDecoration: "none",
                        cursor: "pointer",
                        fontWeight: "bold",
                      }}
                      target="_blank"
                      rel="noopener noreferrer"
                      href={`${baseImageURL}Images/Documents/${item.relocation_id}/${item.doc_name}`}
                      download={`${item.doc_name}`}
                    >
                      Preview{" "}
                      <FontAwesomeIcon
                        icon={faArrowUpRightFromSquare}
                        style={{
                          padding: "5px 4px 0px 11px",
                          color: "#00A3FF",
                        }}
                      />
                    </a>
                  ) : null}
                  {item.is_submit === 2 ? (
                    <button
                      style={{
                        color: "#28A745",
                        fontWeight: "bold",
                        textDecoration: "none",
                        border: "none",
                        backgroundColor: "white",
                        display: "flex",
                      }}
                      onClick={() => submitDocument(item.doc_ID)}
                    >
                      Submit
                      <FontAwesomeIcon
                        icon={faArrowRightFromBracket}
                        style={{
                          padding: "5px 4px 0px 11px",
                          color: "#28A745",
                        }}
                      />
                    </button>
                  ) : (
                    <button
                      style={{
                        color: "#28A745",
                        width: "88%",
                        marginTop: "9.5px",
                        fontWeight: "bold",
                        cursor: "default",
                        textDecoration: "none",
                        border: "none",
                        backgroundColor: "white",
                      }}
                    >
                      Submitted
                    </button>
                  )}

                  {item.is_submit === 2 ? (
                    <button
                      onClick={() => deleteDoc(item.doc_ID)}
                      style={{
                        display: "flex",
                        color: "#FF0004",
                        borderStyle: "none",
                        background: "none",
                      }}
                    >
                      Delete{" "}
                      <DeleteOutlinedIcon
                        className="icon"
                        style={{ padding: "0 0 0 4px" }}
                      />
                    </button>
                  ) : null}
                </div>
              </div>
            ))}
          </>
        ) : null}
       
      </div>
    </>
  );
}

export default ExecutionAndDocumentationMobileStep3;
